import React, { useEffect, useRef, useState } from 'react'
import autosize from 'autosize';
import { IoMdTime } from 'react-icons/io'
import { IoSend } from 'react-icons/io5'
import toast from './toast';
import axios from 'axios';
import Storages from '../helper/storages';
import useEndpoints from '../api/useEndpoints';
import errorHandler from '../api/errorHandler';
import { format } from '@persian-tools/persian-mobile-datepicker';
export default function MessagesCenter() {
    var textarea = useRef()
    var messagesEndRef = useRef()
    var endpoints = useEndpoints()
    var [messages, setMessage] = useState([])
    useEffect(() => {
        autosize(textarea.current);

    }, [])
    useEffect(() => {
        getMessage()

    }, [])

    var getMessage = () => {
        axios.get(endpoints.messages,
            {
                params: { rowCount: 10, pageNumber: 0 },
                headers:
                {
                    'x-auth-token': Storages.getUserToken()
                }
            }).then((res) => {
                console.log(res.data)
                setMessage(res.data.result)
                scrollToBottom()
            }).catch((e) => {
                console.log(e)
                errorHandler(e)
            })
    }

    var scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <>

            <div className=' container overflow-hidden  bottom-0 start-0 top-0 end-0 position-absolute mt-3 mb-5 pb-3' >
                <div className='h-100 card' >
                    <div className=' h-100 overflow-auto aScroll'  >
                        {messages.map((item, index) => {
                            if (item.isSender) {

                                return <div className='card m-2 p-2 bg-info  w-50 '>
                                    <label className='m-0 p-0'><IoMdTime /> {format(new Date(item.saveDate), 'hh:mm yyyy/MM/dd')}</label>
                                    <hr className='m-0 p-0' />
                                    <div className='p-1'>
                                        <p className='m-0 p-0'>{item.note}</p>
                                    </div>
                                </div>
                            } else {
                                return <div className='card m-2 p-2 bg-warning text-dark  me-auto w-50 '>
                                    <label className='m-0 p-0'><IoMdTime /> {format(new Date(item.saveDate), 'hh:mm yyyy/MM/dd')}</label>
                                    <hr className='m-0 p-0' />
                                    <div className='p-1'>
                                        <p className='m-0 p-0'>{item.note}</p>
                                    </div>
                                </div>
                            }
                        })}



                        <div ref={messagesEndRef} />

                    </div>

                    <div className=' w-100  d-flex flex-row justify-content-center align-items-center ps-2 pe-2'>
                        <IoSend size={25} onClick={(e) => {
                        }} />

                        <div className='m-2 card w-100 '>

                            <textarea rows="1"
                                className='form-control aScroll'
                                placeholder='متن پیام'
                                ref={textarea}
                                style={{
                                    maxHeight: '205px',
                                    resize: 'none',
                                }} />
                        </div>

                    </div>
                </div>



            </div>
        </>
    )
}